import { usePostAlerts } from './usePostAlerts';

export const useUnreadAlertsCount = (dateFrom?: string) => {
  const { data } = usePostAlerts({
    count_only: true,
    read: false,
    ...(dateFrom && { date_from: dateFrom }),
  });
  return data?.pages[0]?.count ?? 0;
};
